import React, { ReactElement } from "react";
import { Select } from "antd";
import { FieldProps, useFormikContext } from "formik";

type SelectProps = {
  children: ReactElement;
  onSelect: (val: string) => void;
};



const SelectField: React.FC<FieldProps & SelectProps> = ({
  field,
  form,
  meta,
  children,
  ...props
}) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  return (
    <>
      <Select
        {...field}
        {...props}
        size={"large"}
        style={{ width: "100%" }}
        showSearch
        optionFilterProp="children"
        
        onChange={(val) => {
          setFieldValue(field.name, val);
          if ("onSelect" in props && typeof props.onSelect === "function")
            props?.onSelect(val);
        }}
        onBlur={() => setFieldTouched(field.name)}
      >
        <Select.Option value="" disabled selected>
          Pick an option
        </Select.Option>
        {children}
      </Select>
      {/* {meta?.touched && meta?.error && (
        <div style={{ marginTop: "-3px" }}>{meta?.error}</div>
      )} */}
    </>
  );
};

export default SelectField;
